import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { boot } from 'quasar/wrappers';
import { markRaw } from 'vue';
import { Router } from 'vue-router';
import VueRouter from '../router';
//@ts-ignore
import L from 'leaflet'
import VueDragscroll from 'vue-dragscroll'
import DialogContainer from "src/components/shared/DialogContainer.vue";
import Separator from 'src/components/shared/Separator.vue';
import CheckCircleIcon from 'src/components/shared/svg/CheckCircle.vue';
import FileIcon from 'src/components/shared/svg/File.vue';
import FolderIcon from 'src/components/shared/svg/Folder.vue';
import PipelineIcon from 'src/components/shared/svg/Pipeline.vue';
import TableIcon from 'src/components/shared/svg/Table.vue';
import UserIcon from 'src/components/shared/svg/User.vue';
import SendIcon from 'src/components/shared/svg/Send.vue';
import CardIcon from 'src/components/shared/svg/Card.vue';
import PlusIcon from 'src/components/shared/svg/Plus.vue';
import DocSendIcon from 'src/components/shared/svg/DocSend.vue';
import MenuIcon from 'src/components/shared/svg/Menu.vue';
import BellIcon from 'src/components/shared/svg/Bell.vue';
import Badge from 'src/components/shared/Badge.vue';
import StatusBadge from 'src/components/shared/StatusBadge.vue';
import Tabs from 'src/components/shared/Tabs.vue';
import DropdownSelectButton from 'src/components/shared/inputs/buttons/DropdownSelectButton.vue';
import ImageCarousel from 'src/components/shared/ImageCarousel.vue';
import VehicleInfo from 'src/components/vehicle/VehicleInfo.vue';
import LenderSlider from 'src/components/shared/LenderSlider.vue';
import Wysiwyg from 'src/components/shared/inputs/Wysiwyg.vue';
import CurrencyInput from 'src/components/shared/inputs/CurrencyInput.vue';
import TermSelect from 'src/components/shared/inputs/TermSelect.vue';
import CreditProfileSelect from 'src/components/shared/inputs/CreditProfileSelect.vue';
import DealershipSelect from 'src/components/shared/inputs/DealershipSelect.vue';
import DobInput from 'src/components/shared/inputs/DobInput.vue';
import DrivingLicenceSelect from 'src/components/shared/inputs/DrivingLicenceSelect.vue';
import EmploymentStatusSelect from 'src/components/shared/inputs/EmploymentStatusSelect.vue';
import MaritalStatusSelect from 'src/components/shared/inputs/MaritalStatusSelect.vue';
import ResidentialStatusSelect from 'src/components/shared/inputs/ResidentialStatusSelect.vue';
import EmailInput from 'src/components/shared/inputs/EmailInput.vue';
import PhoneNumberInput from 'src/components/shared/inputs/PhoneNumberInput.vue';
import ProductTypeSelect from 'src/components/shared/inputs/ProductTypeSelect.vue';
import TitleSelect from 'src/components/shared/inputs/TitleSelect.vue';
import MobileNumberInput from 'src/components/shared/inputs/MobileNumberInput.vue';
import CountrySelect from 'src/components/shared/inputs/CountrySelect.vue';
import NumberInput from 'src/components/shared/inputs/NumberInput.vue';
import SelectMulti from 'src/components/shared/inputs/SelectMulti.vue';
import Toggle from 'src/components/shared/forms/Toggle.vue';

import * as Sentry from "@sentry/vue";

/*
 * When adding new properties to stores, you should also
 * extend the `PiniaCustomProperties` interface.
 * @see https://pinia.vuejs.org/core-concepts/plugins.html#typing-new-store-properties
 */
declare module 'pinia' {
  export interface PiniaCustomProperties {
     router: Router;
  }
}

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */


export default boot(({ app }) => {
  let pinia = createPinia();
  pinia.use(piniaPluginPersistedstate);

  pinia.use(({ store }) => {
    store.router = markRaw(VueRouter)
  })

  app.use(pinia);

  app.use(VueDragscroll);

  app.component("DialogContainer", DialogContainer);
  app.component("Separator", Separator);
  app.component("CheckCircleIcon", CheckCircleIcon);
  app.component("FileIcon", FileIcon);
  app.component("FolderIcon", FolderIcon);
  app.component("PipelineIcon", PipelineIcon);
  app.component("TableIcon", TableIcon);
  app.component("UserIcon", UserIcon);
  app.component("SendIcon", SendIcon);
  app.component("CardIcon", CardIcon);
  app.component("PlusIcon", PlusIcon);
  app.component("DocSendIcon", DocSendIcon);
  app.component("MenuIcon", MenuIcon);
  app.component("BellIcon", BellIcon);
  app.component("Badge", Badge);
  app.component("StatusBadge", StatusBadge);
  app.component("Tabs", Tabs);
  app.component("DropdownSelectButton", DropdownSelectButton);
  app.component("ImageCarousel", ImageCarousel);
  app.component("VehicleInfo", VehicleInfo);
  app.component("LenderSlider", LenderSlider);
  app.component("Wysiwyg", Wysiwyg);
  app.component("CurrencyInput", CurrencyInput);
  app.component("TermSelect", TermSelect);
  app.component("CreditProfileSelect", CreditProfileSelect);
  app.component("DealershipSelect", DealershipSelect);
  app.component("DobInput", DobInput);
  app.component("DrivingLicenceSelect", DrivingLicenceSelect);
  app.component("EmploymentStatusSelect", EmploymentStatusSelect);
  app.component("MaritalStatusSelect", MaritalStatusSelect);
  app.component("ResidentialStatusSelect", ResidentialStatusSelect);
  app.component("EmailInput", EmailInput);
  app.component("PhoneNumberInput", PhoneNumberInput);
  app.component("ProductTypeSelect", ProductTypeSelect);
  app.component("TitleSelect", TitleSelect);
  app.component("MobileNumberInput", MobileNumberInput);
  app.component("CountrySelect", CountrySelect);
  app.component("NumberInput", NumberInput);
  app.component("SelectMulti", SelectMulti);
  app.component("Toggle", Toggle);
  //app.config.compilerOptions.isCustomElement = (tag) => ['boodil-widget'].includes(tag);


  app.config.globalProperties.L = L

  // Sentry.init({
  //   app,
  //   dsn: "https://60d086c03166e7fb4bba380656c207c7@o336652.ingest.sentry.io/4506575030583296",
  //   integrations: [
  //     new Sentry.BrowserTracing({
  //       // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  //       tracePropagationTargets: [
  //         /^https:\/\/dealer\.carfinance247\.co\.uk/,
  //         /^https:\/\/white-meadow-05081ef03\.2\.azurestaticapps\.net/,
  //       ],
  //     }),
  //     new Sentry.Replay({
  //       maskAllText: false,
  //       blockAllMedia: false,
  //     }),
  //   ],
  //   // Performance Monitoring
  //   tracesSampleRate: 1.0, //  Capture 100% of the transactions
  //   // Session Replay
  //   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  //   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // });
});

